import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type DeliveryRegion = 'HK' | 'KLN' | 'NT' | 'OS';

interface DeliveryRegionState {
  // 收貨地區（地址為王——客人 2026-09-05 業務規則第二條）：
  // null＝未設定：IP 只做提示與推送，不做任何購買限制；
  // 'OS'（海外）：全站即時隱藏「僅本地可售」商品，只開放可出口商品。
  deliveryRegion: DeliveryRegion | null;
  setDeliveryRegion: (region: DeliveryRegion | null) => void;
}

export const useDeliveryRegionStore = create<DeliveryRegionState>()(
  persist(
    (set) => ({
      deliveryRegion: null,
      setDeliveryRegion: (deliveryRegion) => set({ deliveryRegion }),
    }),
    { name: 'x1493_delivery_region' }
  )
);
